import { useTranslation as e } from "../../../i18n.mjs";
import { FileSourceEnum as t, FileSourceEnumLocoKeys as n } from "../../../enums/file-source-enum.mjs";
import { FileTypeEnum as r, FileTypeEnumLocoKeys as i } from "../../../enums/file-type-enum.mjs";
import { Button as a, Combobox as o, InputGroup as s } from "@systemeio/components";
import { Fragment as c, jsx as l, jsxs as u } from "react/jsx-runtime";
import { ChevronDownIcon as d, SearchMdIcon as f, XIcon as p } from "@systemeio/icons";
//#region src/modules/file-selector/components/file-search.tsx
function m({ data: t, disabled: n, onChange: r, placeholder: i, value: a }) {
	let { t: s } = e(), f = a.map((e) => t.find((t) => t.id === e)).filter((e) => e !== void 0);
	return /* @__PURE__ */ u(o.Root, {
		"aria-label": i,
		disabled: n,
		drawerTitle: i,
		isItemEqualToValue: (e, t) => e.id === t.id,
		itemToStringLabel: (e) => e.caption,
		itemToStringValue: (e) => e.id,
		items: t,
		multiple: !0,
		onValueChange: (e) => r((e ?? []).map((e) => e.id)),
		placeholder: i,
		value: f,
		children: [/* @__PURE__ */ u(o.InputGroup, {
			"aria-label": i,
			children: [/* @__PURE__ */ l(o.Chips, { children: /* @__PURE__ */ l(o.Value, { children: (e) => /* @__PURE__ */ u(c, { children: [
				e.map((e) => /* @__PURE__ */ u(o.Chip, {
					id: e.id,
					children: [e.caption, /* @__PURE__ */ l(o.ChipRemove, { "aria-label": `${s("file_manager.delete")}: ${e.caption}` })]
				}, e.id)),
				/* @__PURE__ */ l(o.OverflowBadge, {}),
				/* @__PURE__ */ l(o.Input, { placeholder: e.length > 0 ? "" : void 0 })
			] }) }) }), /* @__PURE__ */ l(o.Trigger, {
				"aria-label": i,
				children: /* @__PURE__ */ l(d, {})
			})]
		}), /* @__PURE__ */ l(o.Content, { children: /* @__PURE__ */ l(o.List, { children: (e) => /* @__PURE__ */ l(o.Option, {
			value: e,
			children: e.caption
		}, e.id) }) })]
	});
}
function h({ isFetching: o, values: c, disabled: d, disabledFileSourceSelect: h, disabledFileTypeSelect: g, onChange: _, onSubmit: v }) {
	let { t: y } = e(), b = o || d, x = Object.values(t).filter((e) => e !== t.BlockPreview && e !== t.Community).map((e) => ({
		id: e,
		caption: y(n[e])
	})), S = Object.values(r).map((e) => ({
		id: e,
		caption: y(i[e])
	}));
	return /* @__PURE__ */ u("form", {
		onSubmit: (e) => {
			e.preventDefault(), e.stopPropagation(), v();
		},
		className: "tablet:grid-cols-2 desktop:grid-cols-[repeat(3,minmax(0,1fr))_auto] grid grid-cols-1 gap-2",
		children: [
			/* @__PURE__ */ u("label", {
				className: "tablet:contents grid gap-2",
				children: [/* @__PURE__ */ l("span", {
					className: "text-text-primary tablet:col-span-2 desktop:col-span-4 text-lg font-semibold",
					children: y("file_manager.file_selector.search_file")
				}), /* @__PURE__ */ u(s.Root, { children: [
					/* @__PURE__ */ l(s.Input, {
						disabled: b,
						placeholder: y("file_manager.search"),
						spellCheck: !1,
						value: c.name,
						onChange: (e) => _?.({
							...c,
							name: e.target.value
						})
					}),
					/* @__PURE__ */ l(s.Addon, {
						align: "inline-start",
						children: /* @__PURE__ */ l(f, { "aria-hidden": !0 })
					}),
					c.name ? /* @__PURE__ */ l(s.Addon, {
						align: "inline-end",
						children: /* @__PURE__ */ l("button", {
							"aria-label": y("file_manager.cancel"),
							className: "text-icon-secondary hover:text-icon-primary focus-visible:focus-ring-primary transition-base flex size-6 items-center justify-center rounded-sm",
							onClick: () => _?.({
								...c,
								name: ""
							}),
							type: "button",
							children: /* @__PURE__ */ l(p, {
								"aria-hidden": !0,
								className: "size-4"
							})
						})
					}) : null
				] })]
			}),
			/* @__PURE__ */ l(m, {
				data: x,
				disabled: b || h,
				placeholder: y("file_manager.select_source"),
				value: c.source,
				onChange: (e) => _?.({
					...c,
					source: e
				})
			}),
			/* @__PURE__ */ l(m, {
				data: S,
				disabled: b || g,
				placeholder: y("file_manager.select_type"),
				value: c.type,
				onChange: (e) => _?.({
					...c,
					type: e
				})
			}),
			/* @__PURE__ */ l(a, {
				className: "desktop:w-fit min-w-14",
				disabled: d,
				isLoading: o,
				type: "submit",
				children: y("file_manager.search")
			})
		]
	});
}
//#endregion
export { h as FileSearch };
